import * as React from 'react'
import { styled } from '@mui/material/styles'
import { Tooltip, Menu, MenuItem, IconButton } from '@mui/material'
import { useLanguage } from '../../contexts/LanguageContext'
import Language from '../../enums/Language'

const Flag = styled('img')`
  border-radius: 50%;
  width: 24px;
  height: 24px;
`

type Option = {
  icon: string
  name: string
}

function NavbarLanguagesDropdown() {
  const [anchorMenu, setAnchorMenu] = React.useState<(EventTarget & Element) | null>(null)

  const { language, setLanguage } = useLanguage()

  const options: Record<Language, Option> = {
    fi: {
      icon: '/static/img/flags/fi.png',
      name: 'Finnish'
    },
    en: {
      icon: '/static/img/flags/us.png',
      name: 'English'
    },
    swe: {
      icon: '/static/img/flags/se.png',
      name: 'Swedish'
    },
    de: {
      icon: '/static/img/flags/de.png',
      name: 'German'
    },
    no: {
      icon: '/static/img/flags/no.png',
      name: 'Norwegian'
    },
    fr: {
      icon: '/static/img/flags/fr.png',
      name: 'French'
    },
    nl: {
      icon: '/static/img/flags/nl.png',
      name: 'Dutch'
    },
    es: {
      icon: '/static/img/flags/es.png',
      name: 'Spanish'
    }
  }

  const selectedOption = options[language]

  const toggleMenu = (event: React.SyntheticEvent) => {
    setAnchorMenu(event.currentTarget)
  }

  const closeMenu = () => {
    setAnchorMenu(null)
  }

  const changeLanguage = (language: Language) => {
    setLanguage(language)
    closeMenu()
  }

  return (
    <React.Fragment>
      <Tooltip title="Languages">
        <IconButton
          aria-owns={anchorMenu ? 'menu-appbar' : undefined}
          aria-haspopup="true"
          color="inherit"
          size="large"
          onClick={toggleMenu}
        >
          <Flag src={selectedOption.icon} alt={selectedOption.name} />
        </IconButton>
      </Tooltip>
      <Menu id="menu-appbar" anchorEl={anchorMenu} open={Boolean(anchorMenu)} onClose={closeMenu}>
        {Object.keys(options).map((option) => (
          <MenuItem key={option} value={option} onClick={() => changeLanguage(option as Language)}>
            {options[option as Language].name}
          </MenuItem>
        ))}
      </Menu>
    </React.Fragment>
  )
}

export default NavbarLanguagesDropdown
